export default __webpack_public_path__ + "static/media/element_spec_88.8c77446a.webp";